var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: {
            title: "Personal Considerations",
            currentUser: _vm.currentUser,
          },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", {
              attrs: {
                label: "Cultural/Religious Practices",
                value: _vm.data.personal_cultural_practice,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Hobbies/Interests",
                value: _vm.data.personal_hobbies,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Social Connections",
                value: _vm.data.personal_social,
                defaultText: "N/A",
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "General Notes",
                value: _vm.data.personal_notes,
                defaultText: "N/A",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }